import { render, staticRenderFns } from "./EntButton.vue?vue&type=template&id=2c84da22"
import script from "./EntButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EntButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports